import React from 'react';

import { Notice, MarginRight, NoticeText } from './Styled';

export const OrderStatusNotice = ({
  text,
  strong,
  color,
  renderIcon,
  secondaryColor,
  fontWeight = strong ? 400 : 300
}) => (
  <Notice
    strong={strong}
    color={color}
    lightColor={secondaryColor}
  >
    {renderIcon && <MarginRight>{renderIcon()}</MarginRight>}
    <NoticeText
      strong={strong}
      size={'16px'}
      color={color}
      fontWeight={fontWeight}
    >
      {text}
    </NoticeText>
  </Notice>
);

export default OrderStatusNotice;
